// import { useEffect, useState } from 'react';

// const styles = {
//     orientation: {
//         vertical: 'space-y-4',
//         horizontal: 'space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10',
//     },
// };

// type RadioOption = {
//     label: string;
//     description?: string;
//     value: string;
// };

// type RadioGroupProps = {
//     legend: string;
//     name: string;
//     options: RadioOption[];
//     orientation?: 'vertical' | 'horizontal';
//     onSelect: (value: string) => void;
//     defaultValue?: string;
// };

// function RadioGroup({ legend, name, onSelect, options = [], orientation = 'vertical', defaultValue }: RadioGroupProps): JSX.Element {
//     const [selected, setSelected] = useState(defaultValue);
//     useEffect(() => {
//         setSelected(defaultValue);
//     }, [defaultValue]);
//     return (
//         <div>
//             <fieldset>
//                 <legend className="sr-only">{legend}</legend>
//                 <div className={styles.orientation[orientation]}>
//                     {options.map((option, i) => {
//                         return (
//                             <RadioButton
//                                 option={option}
//                                 orientation={orientation}
//                                 groupName={name}
//                                 key={option.value}
//                                 onChange={(value): void => {
//                                     setSelected(value);
//                                     onSelect(value);
//                                 }}
//                                 selected={option.value === selected}
//                             />
//                         );
//                     })}
//                 </div>
//             </fieldset>
//         </div>
//     );
// }

// type RadioOptionProps = {
//     option: RadioOption;
//     groupName: string;
//     orientation: 'vertical' | 'horizontal';
//     onChange: (value: string) => void;
//     selected: boolean;
// };

// function RadioButton({ option, groupName, orientation, onChange, selected }: RadioOptionProps): JSX.Element {
//     const btnCls = `flex ${option.description && orientation !== 'horizontal' ? 'items-start' : 'items-center'}`;
//     const inputCls = 'focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300';
//     return (
//         <div key={option.value} className={btnCls}>
//             <input
//                 checked={selected}
//                 id={option.value}
//                 value={option.value}
//                 name={groupName}
//                 type="radio"
//                 className={inputCls}
//                 onChange={(e): void => onChange(e.target.value)}
//             />
//             <RadioLabel option={option} orientation={orientation} />
//         </div>
//     );
// }

// type RadioLabelProps = {
//     option: RadioOption;
//     orientation: 'vertical' | 'horizontal';
// };

// function RadioLabel({ option, orientation }: RadioLabelProps): JSX.Element {
//     if (orientation === 'horizontal' || !option.description) {
//         return (
//             <label htmlFor={option.value} className="ml-3 block text-sm font-medium text-gray-700">
//                 {option.label}
//             </label>
//         );
//     }

//     return (
//         <div className="ml-3 text-sm">
//             <label htmlFor={option.value} className="font-medium text-gray-700">
//                 {option.label}
//             </label>
//             <p id={`${option.value}-description`} className="text-gray-500">
//                 {option.description}
//             </p>
//         </div>
//     );
// }

export type RadioGroupProps = {
    /**
     * Options the user can select.
     */
    options: { label: string; value: string; disabled?: boolean }[];

    /**
     * Internal name to group the radio buttons.
     */
    groupName: string;

    /**
     * Orientation to display the group.
     */
    orientation?: 'horizontal' | 'vertical';

    /**
     * Which radio button is selected
     */
    value?: string;

    /**
     * Callback function invoked when a radio button is selected.
     */
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

function RadioGroup({ options = [], groupName, orientation = 'vertical', value, onChange, ...props }: RadioGroupProps): JSX.Element {
    return (
        // @ts-ignore
        <fieldset>
            <div className={`space-y-4 ${orientation === 'horizontal' ? 'sm:flex sm:items-center sm:space-y-0 sm:space-x-10' : ''} `}>
                {options.map((option) => {
                    const disabledStyle = option.disabled ? 'cursor-default opacity-[0.65]' : 'cursor-pointer';
                    return (
                        <div key={option.value} className="flex items-center">
                            <input
                                id={option.value}
                                name={groupName}
                                type="radio"
                                disabled={option.disabled}
                                checked={option.value === value}
                                className={`${disabledStyle} focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300`}
                                onChange={(e): void => onChange && onChange(e)}
                                value={option.value}
                                {...props}
                            />
                            <label htmlFor={option.value} className={`${disabledStyle} ml-3 block text-sm font-medium text-gray-700`}>
                                {option.label}
                            </label>
                        </div>
                    );
                })}
            </div>
        </fieldset>
    );
}

export default RadioGroup;
